import VizSensor from "component/design-system/VizSensor";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import commonStyles from "../contact-us/contactUs.module.scss";
import styles from "./storesLocation.module.scss";

const GoogleMap = dynamic(() => import(/* webpackChunkName: "google-map" */ "component/design-system/google-map/GoogleMap"));

function StoresLocation(props: any) {
  const { pickupLocations = [] } = props;
  const { t } = useTranslation("static-pages");
  return pickupLocations.map((pickupLocation: any) => {
    const {
      title, streetAddressLineOne, streetAddressLineTwo, city, state, postalCode,
      timings, latitude, longitude,
    } = pickupLocation;
    return (
      <div className={styles.each_section} key={title}>

        <div className={`d-flex ${commonStyles.mb_2}`} style={{ paddingLeft: "calc(.6 * var(--safari-root-font, 10px))" }}>

          <span>

            <i className={`fa fa-map-marker ${commonStyles.fa_styling}`} aria-hidden="true" />
          </span>

          <div className="d-flex flex-column text-left">

            <span className={`${commonStyles.subheading} ${commonStyles.ml_2}`}>{title}</span>

            <div className={`store-address  ${commonStyles.ml_2}`}>
              {streetAddressLineOne}
              {!streetAddressLineTwo && ","}

              <br />
              {streetAddressLineTwo}
              {streetAddressLineTwo && ", "}
              {city}
              {", "}
              {state}
              {" "}
              {postalCode}
              {" "}

              <br />
              {/* 1-844-850-5333, Ext - 6 */}
            </div>
          </div>
        </div>

        <div className={`d-flex  ${commonStyles.mb_2}`}>

          <span>

            <i className={`fa fa-clock-o ${commonStyles.fa_styling}`} aria-hidden="true" />
          </span>

          <div className="d-flex flex-column text-left">

            <span className={`${commonStyles.subheading} ${commonStyles.ml_2}`}>{t("Store Hours")}</span>
            {
              timings.map((timing: any, index: number) => (
                <div className={commonStyles.ml_2} key={index}>
                  <span className={commonStyles.days}>
                    {timing[0]}
                    :
                  </span>
                  <span className={commonStyles.hours}>{timing[1]}</span>
                </div>
              ))
            }
          </div>
        </div>

        <VizSensor>
          <GoogleMap lat={parseFloat(latitude)} lng={parseFloat(longitude)} />
        </VizSensor>

        {/* <VizSensor>
          <GoogleMap
            lat={parseFloat(latitude)}
            lng={parseFloat(longitude)}
            boundaryCoords={[
              { lat: 40.7128, lng: -74.0060 },
              { lat: 40.7158, lng: -74.0020 },
              { lat: 40.7188, lng: -74.0080 },
              { lat: 40.7128, lng: -74.0060 },
            ]}
          />
        </VizSensor> */}
      </div>
    );
  });
}

export default StoresLocation;
